module.exports = __webpack_public_path__ + "0462ea74ac7ce97d07c1e8941b2133a9.woff2";